import { createSelector } from 'reselect';

import { FEATURES } from '@/constants';
import { getFeatureConfig } from '@/selectors/featuresConfig';
import { getMerchantCountryKey } from '@/selectors/merchant';

/**
 * Creates a selector that provides a validation feature config defined on the Experimentation
 * platform. The config is only returned if it includes the merchant's country and the passed field
 * name, otherwise undefined is returned.
 * @param {string} fieldName Field name that is included in the feature config
 * @returns Feature config object
 */
export const getForcedFieldValidationConfig = fieldName =>
  createSelector(
    getMerchantCountryKey,
    getFeatureConfig(FEATURES.FORCE_FIELD_VALIDATION),
    (merchantCountry, featureConfig = { countries: '' }) => {
      return featureConfig.is_enabled === 'true' &&
        featureConfig.field === fieldName &&
        featureConfig.countries.split(',').includes(merchantCountry)
        ? featureConfig
        : undefined;
    },
  );
